module.exports = __webpack_public_path__ + "assets/9d1c5657ea3481a8ae6218d300055afa.png";